module.exports = __webpack_public_path__ + "img/g2.2d22ef74.jpg";